import { render } from "./order_detail_examine.vue?vue&type=template&id=6f7b3506"
import script from "./order_detail_examine.vue?vue&type=script&lang=js"
export * from "./order_detail_examine.vue?vue&type=script&lang=js"

import "./order_detail_examine.vue?vue&type=style&index=0&id=6f7b3506&lang=scss"

import exportComponent from "E:\\javaproject\\jingniu\\pes-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__